import { EmployersBody } from "./EmployersBody";
import { Footer } from "./Footer";
import { Header } from "./Header";
import SignIn3mix from '../After_Sign_In/New_mix';


export function GdforEmp(){
    return (
        <>
        <Header/>
        <EmployersBody/>
        <SignIn3mix />
        <Footer/>
        </>
    )
}